var _linearGradient, _path, _radialGradient, _path2, _radialGradient2, _path3, _linearGradient2, _path4, _radialGradient3, _path5, _radialGradient4, _path6, _linearGradient3, _path7, _linearGradient4, _path8, _linearGradient5, _path9, _linearGradient6, _path10, _radialGradient5, _path11, _linearGradient7, _path12, _linearGradient8, _path13, _linearGradient9, _path14, _linearGradient10, _path15, _linearGradient11, _path16, _linearGradient12, _path17, _radialGradient6, _path18, _linearGradient13, _path19, _radialGradient7, _path20, _linearGradient14, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailboxColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 458.986667,
    y1: 480.54,
    x2: 458.986667,
    y2: 182.909667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#008ee6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#80dafe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#76d5fb",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#5cc8f3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9026,
    stopColor: "#32b2e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6",
    stopOpacity: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "url(#linearGradient1)",
    stroke: "none",
    d: "M 586.856628 176.562683 L 213.143005 176.562683 L 331.047668 516.753296 L 488.379974 516.753296 L 704.763367 516.753296 L 704.763367 392.943329 L 704.763367 294.657684 C 704.763367 229.324341 652 176.562683 586.856628 176.562683 Z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1",
    cx: 683.336667,
    cy: 615.483333,
    r: 453.13,
    fx: 683.336667,
    fy: 615.483333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "url(#radialGradient1)",
    stroke: "none",
    opacity: 0.75,
    d: "M 586.856628 176.562683 L 213.143005 176.562683 L 331.047668 516.753296 L 488.379974 516.753296 L 704.763367 516.753296 L 704.763367 392.943329 L 704.763367 294.657684 C 704.763367 229.324341 652 176.562683 586.856628 176.562683 Z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient2",
    cx: 392.186667,
    cy: 182.976,
    r: 378.03,
    fx: 392.186667,
    fy: 182.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "url(#radialGradient2)",
    stroke: "none",
    opacity: 0.75,
    d: "M 586.856628 176.562683 L 213.143005 176.562683 L 331.047668 392.753357 L 704.570007 392.753357 L 704.570007 294.467316 C 704.763367 229.324341 652 176.562683 586.856628 176.562683 Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2",
    x1: -55.346667,
    y1: 160.251333,
    x2: 527.96,
    y2: 629.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#8ea5a8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#000000",
    stopOpacity: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "url(#linearGradient2)",
    stroke: "none",
    d: "M 213.143005 182.27533 C 150.095337 182.27533 99.048004 233.322998 99.048004 296.370667 L 99.048004 390.84668 L 99.048004 510.84668 L 327.42865 510.84668 L 327.42865 390.84668 L 327.42865 296.370667 C 327.42865 233.322998 276.190674 182.27533 213.143005 182.27533 Z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient3",
    cx: 181.179333,
    cy: 399.516667,
    r: 102.394667,
    fx: 181.179333,
    fy: 399.516667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#fffcf9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#fdf3e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#fbe4c9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faddbc",
    stopOpacity: 1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "url(#radialGradient3)",
    stroke: "none",
    d: "M 143.421997 289.697327 C 138.088669 289.697327 133.707672 293.697327 133.707672 298.840027 L 133.707672 497.696655 C 133.707672 502.649994 138.088669 506.839996 143.421997 506.839996 L 325.32666 506.839996 L 325.32666 389.31665 L 325.32666 289.697327 L 143.421997 289.697327 L 143.421997 289.697327 Z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient4",
    cx: 261.503667,
    cy: 486.72,
    r: 226.13061,
    fx: 261.503667,
    fy: 486.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#fffcf9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#fdf3e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#fbe4c9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faddbc",
    stopOpacity: 1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "url(#radialGradient4)",
    stroke: "none",
    d: "M 325.32666 394.080017 L 271.231323 327.604004 L 133.707672 496.936676 C 133.707672 502.459991 137.707657 506.843353 142.660004 506.843353 L 325.32666 506.843353 L 325.32666 394.080017 L 325.32666 394.080017 Z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3",
    x1: 229.433333,
    y1: 518.083333,
    x2: 229.433333,
    y2: 383.633333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#fffcf9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#fdf3e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#fbe4c9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faddbc",
    stopOpacity: 1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "url(#linearGradient3)",
    stroke: "none",
    d: "M 325.32666 394.080017 L 271.231323 327.604004 L 133.707672 496.936676 C 133.707672 502.459991 137.707657 506.843353 142.660004 506.843353 L 325.32666 506.843353 L 325.32666 394.080017 L 325.32666 394.080017 Z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4",
    x1: 255.105333,
    y1: 284.954333,
    x2: 133.200667,
    y2: 531.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001326,
    stopColor: "#fcd2a8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#fbb87a",
    stopOpacity: 0
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "url(#linearGradient4)",
    stroke: "none",
    d: "M 200.18399 395.980011 L 216.374329 395.980011 L 133.707672 497.883331 L 200.18399 395.980011 Z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5",
    x1: 215.717,
    y1: 265.497333,
    x2: 93.812333,
    y2: 512.163333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001326,
    stopColor: "#fcd2a8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#fbb87a",
    stopOpacity: 0
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "url(#linearGradient5)",
    stroke: "none",
    d: "M 200.186996 395.98999 L 216.37767 395.98999 L 133.52066 299.609344 L 200.186996 395.98999 Z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6",
    x1: 269.402333,
    y1: 336.116667,
    x2: 267.870667,
    y2: 503.556667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001326,
    stopColor: "#fcd2a8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#fbb87a",
    stopOpacity: 0
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "url(#linearGradient6)",
    stroke: "none",
    d: "M 292.182678 435.600006 C 280.944336 448.549988 262.277679 448.549988 251.039658 435.600006 L 216.373001 395.980011 L 212.182663 401.123322 L 243.230331 437.883331 C 250.658676 446.456665 260.753998 453.313324 271.610992 453.313324 C 282.468323 453.313324 292.372986 446.646667 299.992004 437.883331 L 325.325317 408.170013 L 325.325317 399.216644 L 292.182678 435.600006 Z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient5",
    cx: 287.850333,
    cy: 381.566667,
    r: 222.148,
    fx: 287.850333,
    fy: 381.566667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#fffcf9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#fdf3e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8689,
    stopColor: "#fbe4c9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faddbc",
    stopOpacity: 1
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "url(#radialGradient5)",
    stroke: "none",
    d: "M 325.330017 389.31665 L 325.330017 289.697327 L 142.472992 289.697327 C 137.52066 289.697327 133.52066 294.268677 133.52066 299.792664 L 251.044342 438.07666 C 262.282349 451.410004 280.948975 451.410004 292.187347 438.07666 L 325.330017 399.220001 L 325.330017 389.31665 L 325.330017 389.31665 Z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7",
    x1: 1.83316,
    y1: 873.006667,
    x2: 438.653333,
    y2: -118.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#008ee6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#80dafe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#76d5fb",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#5cc8f3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9026,
    stopColor: "#32b2e6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6",
    stopOpacity: 1
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "url(#linearGradient7)",
    stroke: "none",
    d: "M 213.143997 176.562683 C 148.001007 176.562683 95.239334 229.324341 95.239334 294.467316 L 95.239334 392.753357 L 95.239334 516.563354 L 331.239319 516.563354 L 331.239319 392.753357 L 331.239319 294.467316 C 331.239319 229.324341 278.286987 176.562683 213.143997 176.562683 Z M 321.33432 506.84668 L 105.143997 506.84668 L 105.143997 294.467316 C 105.143997 234.848328 153.715347 186.276672 213.334335 186.276672 C 272.953674 186.276672 321.524994 234.848328 321.524994 294.467316 L 321.524994 506.84668 L 321.33432 506.84668 Z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8",
    x1: 570.643878,
    y1: 292.584858,
    x2: 543.236055,
    y2: 475.641976,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-0 1 -1 -0 973.834991 -131.88501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#bd2719",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#d41a10",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#ec0c07",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#fa0302",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0000",
    stopOpacity: 1
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "url(#linearGradient8)",
    stroke: "none",
    visibility: "hidden",
    d: "M 441.149445 398 L 686 398 L 652.143616 443.949982 L 441.149445 443.949982 C 429.292267 443.949982 419.720001 433.676331 419.720001 420.878326 C 419.720001 408.2771 429.292267 398 441.149445 398 Z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient9",
    x1: 618.814934,
    y1: 600.710668,
    x2: 669.057785,
    y2: 394.384668,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-0 1 -1 -0 1109.243668 -199.436996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#fc8d41",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.090032,
    stopColor: "#fc7837",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#fd4d24",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#fe2c14",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#ff1409",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#ff0502",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0000",
    stopOpacity: 1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "url(#linearGradient9)",
    stroke: "none",
    visibility: "hidden",
    d: "M 685.768982 512 L 685.768982 397.806671 L 622.911682 397.806671 L 622.911682 512 L 685.768982 512 Z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10",
    x1: 459.85,
    y1: 101.564333,
    x2: 432.923333,
    y2: 345.646667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#bd2719",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#d41a10",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#ec0c07",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#fa0302",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0000",
    stopOpacity: 1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "url(#linearGradient10)",
    stroke: "none",
    d: "M 419.806671 421.706665 L 419.806671 95.231018 L 464.949982 140.374023 L 464.949982 421.706665 C 464.949982 437.516663 454.856689 450.279999 442.283356 450.279999 C 429.903351 450.279999 419.806671 437.516663 419.806671 421.706665 Z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient11",
    x1: 446.936667,
    y1: 272.467,
    x2: 510.126667,
    y2: 66.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#fc8d41",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.090032,
    stopColor: "#fc7837",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#fd4d24",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#fe2c14",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#ff1409",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#ff0502",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0000",
    stopOpacity: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "url(#linearGradient11)",
    stroke: "none",
    d: "M 563.426636 95.231018 L 419.806671 95.231018 L 419.806671 158.088318 L 563.426636 158.088318 L 563.426636 95.231018 Z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient12",
    x1: 436.79,
    y1: 402.85,
    x2: 486.92,
    y2: 568.013333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#bd2719",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#d41a10",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#ec0c07",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#fa0302",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0000",
    stopOpacity: 1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "url(#linearGradient12)",
    stroke: "none",
    d: "M 457.333344 421.513336 C 457.333344 411.22998 450.666687 402.846649 442.476654 402.846649 C 434.286652 402.846649 427.619995 411.22998 427.619995 421.513336 C 427.619995 431.800018 434.286652 440.183319 442.476654 440.183319 C 450.666687 440.183319 457.333344 431.800018 457.333344 421.513336 Z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient6",
    cx: 399.173333,
    cy: 693.596667,
    r: 563.463333,
    fx: 399.173333,
    fy: 693.596667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "url(#radialGradient6)",
    stroke: "none",
    opacity: 0.75,
    d: "M 321.333649 506.853333 L 105.143333 506.853333 L 105.143333 516.756653 L 321.333649 516.756653 L 321.333649 506.853333 Z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient13",
    x1: 272.819,
    y1: 656.39,
    x2: 536.593333,
    y2: 559.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#939fa1",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1854,
    stopColor: "#8e999b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    stopColor: "#7f8788",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7438,
    stopColor: "#666b6b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4c",
    stopOpacity: 1
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fill: "url(#linearGradient13)",
    stroke: "none",
    d: "M 444.193329 516.553345 L 349.526672 516.553345 L 349.526672 704.743347 L 444.193329 704.743347 L 444.193329 516.553345 Z"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7",
    cx: 391.76,
    cy: 626.783333,
    r: 46.575777,
    fx: 391.76,
    fy: 626.783333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#dee7e8",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#dee7e8",
    stopOpacity: 0
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "url(#radialGradient7)",
    stroke: "none",
    opacity: 0.5,
    d: "M 444.193329 516.553345 L 349.526672 516.553345 L 349.526672 704.743347 L 444.193329 704.743347 L 444.193329 516.553345 Z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14",
    x1: 402.293333,
    y1: 660.32,
    x2: 388.96,
    y2: 489.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 1
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "url(#linearGradient14)",
    stroke: "none",
    opacity: 0.5,
    d: "M 349.526672 516.553345 L 349.526672 664.743347 C 349.526672 667.410034 370.670013 669.503357 396.766663 669.503357 C 422.859985 669.503357 444.003326 667.410034 444.003326 664.743347 L 444.003326 516.553345 L 349.526672 516.553345 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailboxColor);
export default __webpack_public_path__ + "static/media/mailbox_color.5960d34c8d08f42f6fa0f46cdbd01aee.svg";
export { ForwardRef as ReactComponent };